import { Suspense, lazy, memo } from 'react';
import Loading from './Loading';
const Hero = (content: any) => {
	if (content.video) {
		return (
			content && <div className="hero card">
				<Suspense fallback={<Loading />}>
					{/* <ReactPlayer
						url={content.video}
						playing={true}
						loop={true}
						muted={true}
						playsinline={true}
						width={content.width}
						height={content.height}
						style={content.style}
						onError={(error : any) => console.log("Video error ", error.message)}
					/> */}
					<video
						src={content.video}
						autoPlay={true}
						width={content.width}
						height={content.height}
						style={content.style}
						playsInline={true}
						loop={true}
						muted={true}
					/>
				</Suspense>
				<div className="card-img-overlay">{content.children}</div>
			</div>
		)
	}
	return content && (
		<div className={"hero card overflow-hidden " + content.heroClass} style={{ height: content.height }}>
			<img loading="lazy" src={content.image} className={content.className} width="100%" height="100%" alt="Image" />
			<div className={"card-img-overlay " + content.bgColor + " " + content.opacity}></div>
			{
				content.children &&
				<div className={"card-img-overlay ps-10 d-flex flex-column mx-lg-40 mx-md-15 mx-sm-10 mb-8 " + content.alignment}>
					<h1 className={content.children.props?.className}>{content.children.props?.children}</h1>
				</div>
			}
		</div>
	)
}
export default memo(Hero, (prev, next) => {
	return prev?.video !== next?.video
})